import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { Injectable } from '@angular/core'
import { AuthenticationService } from './authentication.service'
import { catchError } from 'rxjs/operators'
import { Router } from '@angular/router'
import notify from 'devextreme/ui/notify'
import AppUtils from 'src/app/modules/shared/utils/app-utils'

@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers = new HttpHeaders()
    if (!request.headers.has('Content-Type')) {
      headers = headers.append('Content-Type', 'application/json')
    }
    if (this.authenticationService.isAuthenticated()) {
      headers = headers.append('Authorization', `Bearer ${this.authenticationService.getToken()}`)
    }
    request = request.clone({ headers })

    return next.handle(request).pipe(
      catchError(this.handleError())
    )
  }

  private handleError() {
    return (error: any): Observable<HttpEvent<any>> => {
      // get & display error message
      const msg = AppUtils.getErrorText(error)
      // redirect on 401
      if (error.status === 401) {
        notify(msg, 'error', 6000)
        this.authenticationService.logout()
      }
      // redirect on 403
      if (error.status === 403) {
        notify(msg, 'error', 6000)
        this.authenticationService.logoutActions()
      }
      // redirect on 404
      if (error.status === 404) {
        notify(msg, 'error', 6000)
        this.router.navigate(['404'])
      }
      // redirect on 500
      if (error.status === 500) {
        notify(msg, 'error', 6000)
        this.router.navigate(['500'])
      }
      // if (error && error.error) {
      //   let msg = 'Unknown error';
      //   if (error.error.Message) { msg = error.error.Message; }
      //   notify(msg, 'error', 6000);
      // }

      return throwError(error)
    }
  }
}
